import React, { useCallback, useMemo, useState } from 'react';
import { useRequest } from 'ahooks';
import Panel from '../index';
import { RadialBar } from '@ant-design/charts';
import { Spin } from 'antd';
import { GetParkingPotential} from '@/services/api';
import cn from 'classnames'
import styles from './index.module.scss';
import ImgSource from '@/assets/img/tingchenan/tingcheliyonglv.png'
import { ScrollRankingBoard } from '@jiaminghi/data-view-react';

export interface ParkingUsageProps {
  areaCode?: string;
}

// 转换数据格式的方法
const transformData = (data: any) => {
  if (!data) return [];
  
  return Object.entries(data).map(([name, value]) => ({
    name,
    value: Number(value) || 0
  }));
};

const KeyCarTable: React.FC<ParkingUsageProps> = ({ areaCode }) => {
  const { data: useRateData={}, loading, error } = useRequest(useCallback(() => {
    return GetParkingPotential({areaCode});
  }, [areaCode]), {
    formatResult: res => res.data,
    refreshDeps: [areaCode]
  })
  
  const config = useMemo(() => ({
    data: transformData(useRateData)
  }), [useRateData]);
 
  if (loading) {
    return (
      <Panel title="错时潜力挖掘" >
        <div className="fetch_container" style={{ height: 200 }}>
          <Spin />
        </div>
      </Panel>
    )
  }

  if (error) {
    return (
      <Panel title="错时潜力挖掘"  >
        <div className="fetch_container" style={{ height: 200 }}>
          请求错误
        </div>
      </Panel>
    )
  }
  
  return (
    <Panel
      title="错时潜力挖掘"
    >
      <div className={styles.container}>
        <ScrollRankingBoard config={config} style={{width: '380px', height: '200px'}} />
      </div>
    </Panel>
  )
}

export default KeyCarTable;